/**
 * AP Invoices Demo — registers Nami's "make me an AP processing workflow" +
 * "auto-accept high-confidence invoices" tools.
 *
 * THROWAWAY DEMO CODE. The build prompt is typed on the Workflows list page (not
 * the demo canvas), so these tools must already be registered when the
 * interceptor fires — this tiny component is mounted globally (in the
 * authenticated route) and registers them with the AP demo tool registry. The
 * interceptor streams the narration, then fires the tool, which flips the build
 * flags and navigates to the demo canvas where the steps stream in. Renders
 * nothing. Delete with src/demo/ap.
 */

import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import paths from '@/paths';
import { isApDemoMode } from '../demo-mode';
import { registerApDemoTool } from '../agent/script';
import { addApConfidenceStep, startApWorkflowBuild } from './build-actions';

function ApWorkflowTools() {
  const navigate = useNavigate();

  useEffect(() => {
    registerApDemoTool('ap_build_processing_workflow', () => {
      startApWorkflowBuild();
      void navigate({ to: paths.authenticated.demoApWorkflow });
    });

    registerApDemoTool('ap_add_confidence_step', () => {
      addApConfidenceStep();
      void navigate({ to: paths.authenticated.demoApWorkflow });
    });
  }, [navigate]);

  return null;
}

/** Mount guard so the tools register only in demo mode. */
export function ApWorkflowToolsMount() {
  if (!isApDemoMode()) return null;
  return <ApWorkflowTools />;
}
